import {
  FIELD_FILTERS_ALLOWED_MODULE,
  FIELD_FILTERS_ENTITY,
} from '@features/filters/types';

export const STRING_FIELD_VALIDATION_MAX_VALUE = 255;

const {
  ID,
  CODE,
  NAME,
  TYPE,
  BRANDS,
  HIDDEN,
  BONUSES,
  ENABLED,
  TRIGGER,
  BRAND_ID,
  CATEGORY,
  DECISION,
  EVENT_ID,
  GIVEN_AT,
  GIVEN_TO,
  PLAYER_ID,
  CAMPAIGN_ID,
  FAILED_CHECK,
  OFFER_STATUS,
  TARGET_GROUP,
  TRIGGER_TYPE,
  CAMPAIGN_NAME,
  CAMPAIGN_TYPE,
  BET_ACTION_TYPE,
  TRIGGER_DATE_TO,
  ACTIVATION_ACTION,
  BONUS_TEMPLATE_ID,
  PRIMARY_CRITERION,
  TRIGGER_DATE_FROM,
  CAMPAIGN_END_DATE,
  CAMPAIGN_START_DATE,
  SHOW_ADVANCED_FILTERS,
  CONTRIBUTION_CREATED_AT_TO,
  CONTRIBUTION_REPORT_GAME_ID,
  CONTRIBUTION_CREATED_AT_FROM,
  CONTRIBUTION_REPORT_GAME_TYPE_ID,
  CONTRIBUTION_REPORT_BET_REFERENCE,
  CONTRIBUTION_REPORT_GAME_SUB_PROVIDER_ID,
} = FIELD_FILTERS_ENTITY;

export const monitorReportEnabledFilters = [
  BONUS_TEMPLATE_ID,
  BRAND_ID,
  CAMPAIGN_ID,
  CAMPAIGN_TYPE,
  CATEGORY,
  DECISION,
  EVENT_ID,
  FAILED_CHECK,
  HIDDEN,
  OFFER_STATUS,
  PLAYER_ID,
  SHOW_ADVANCED_FILTERS,
  TRIGGER_DATE_FROM,
  TRIGGER_DATE_TO,
  TRIGGER_TYPE,
] as FIELD_FILTERS_ENTITY[];

export const activityReportEnabledFilters = [
  BONUS_TEMPLATE_ID,
  BRAND_ID,
  CAMPAIGN_ID,
  CATEGORY,
  ENABLED,
  GIVEN_AT,
  GIVEN_TO,
  SHOW_ADVANCED_FILTERS,
  TYPE,
  CAMPAIGN_TYPE,
] as FIELD_FILTERS_ENTITY[];

export const codeCampaignEnabledFilters = [
  ID,
  ENABLED,
  TARGET_GROUP,
  BRANDS,
  ACTIVATION_ACTION,
  BONUSES,
  CODE,
  CAMPAIGN_NAME,
  CAMPAIGN_START_DATE,
  CAMPAIGN_END_DATE,
] as FIELD_FILTERS_ENTITY[];

export const automaticCampaignEnabledFilters = [
  ID,
  ENABLED,
  TARGET_GROUP,
  BRANDS,
  TRIGGER,
  BONUSES,
  BET_ACTION_TYPE,
  CAMPAIGN_NAME,
  CAMPAIGN_START_DATE,
  CAMPAIGN_END_DATE,
] as FIELD_FILTERS_ENTITY[];

export const scheduledCampaignEnabledFilters = [
  ID,
  ENABLED,
  TARGET_GROUP,
  BRANDS,
  BONUSES,
  PRIMARY_CRITERION,
  CAMPAIGN_NAME,
  CAMPAIGN_START_DATE,
  CAMPAIGN_END_DATE,
] as FIELD_FILTERS_ENTITY[];

export const bonusManagementEnabledFilters = [
  ID,
  ENABLED,
  TYPE,
  BRANDS,
  NAME,
] as FIELD_FILTERS_ENTITY[];

export const bonusesPendingReviewEnabledFilters = [
  FIELD_FILTERS_ENTITY.OCCURRENCE_DATE_FROM,
  FIELD_FILTERS_ENTITY.OCCURRENCE_DATE_TO,
  BRAND_ID,
  FIELD_FILTERS_ENTITY.CAMPAIGN_ID,
  FIELD_FILTERS_ENTITY.CAMPAIGN_EXECUTION_ID,
  FIELD_FILTERS_ENTITY.SHOW_ONLY_PENDING_REVIEWS,
] as const satisfies readonly FIELD_FILTERS_ENTITY[];

export const monitorReportAdvancedFilterIds = [
  BONUS_TEMPLATE_ID,
  BRAND_ID,
  CAMPAIGN_ID,
  CAMPAIGN_TYPE,
  CATEGORY,
  DECISION,
  EVENT_ID,
  FAILED_CHECK,
  HIDDEN,
  OFFER_STATUS,
  SHOW_ADVANCED_FILTERS,
  TRIGGER_TYPE,
];

export const contributionBetsReportEnabledFilters = [
  CONTRIBUTION_REPORT_BET_REFERENCE,
  CONTRIBUTION_REPORT_GAME_SUB_PROVIDER_ID,
  CONTRIBUTION_REPORT_GAME_TYPE_ID,
  CONTRIBUTION_REPORT_GAME_ID,
  CONTRIBUTION_CREATED_AT_FROM,
  CONTRIBUTION_CREATED_AT_TO,
] as const satisfies readonly FIELD_FILTERS_ENTITY[];

export const enabledFieldsPerModuleMap = {
  [FIELD_FILTERS_ALLOWED_MODULE.BONUS]: bonusManagementEnabledFilters,
  [FIELD_FILTERS_ALLOWED_MODULE.CODE_CAMPAIGN]: codeCampaignEnabledFilters,
  [FIELD_FILTERS_ALLOWED_MODULE.CAMPAIGN_MONITOR]: monitorReportEnabledFilters,
  [FIELD_FILTERS_ALLOWED_MODULE.CAMPAIGN_ACTIVITY]:
    activityReportEnabledFilters,
  [FIELD_FILTERS_ALLOWED_MODULE.AUTOMATIC_CAMPAIGN]:
    automaticCampaignEnabledFilters,
  [FIELD_FILTERS_ALLOWED_MODULE.SCHEDULED_CAMPAIGN]:
    scheduledCampaignEnabledFilters,
  [FIELD_FILTERS_ALLOWED_MODULE.BONUSES_PENDING_REVIEW]:
    bonusesPendingReviewEnabledFilters,
  [FIELD_FILTERS_ALLOWED_MODULE.CONTRIBUTION_BETS_REPORT]:
    contributionBetsReportEnabledFilters,
};
